import { inject, Injectable, Injector } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/common';

import { BaseDialogComponent } from '@pp/core/components';
import { DialogData } from '@pp/core/entities';

@Injectable()
export class PpDialogService {
  readonly #dialogService = inject(DialogService);

  open<T, V>(props: DialogData<T, V>, injector?: Injector): DialogRef {
    return this.#dialogService.open(
      BaseDialogComponent,
      {
        ...props,
      },
      { parentInjector: injector },
    );
  }
}
